import React from "react";
import { Menu } from "antd";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { SimpleParagraph } from "../common/Paragraph";
import { Link } from "react-router-dom";
import style from "./index.module.less";
import { useSelector } from "react-redux";

const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

const Inlinenavbar = ({ items, setVisible }) => {
  const [openKeys, setOpenKeys] = React.useState(["sub1"]);
  const isLoggedIn = useSelector((state) => state.auth);
  const auth = localStorage.getItem("admin");
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <Menu
      selectable={false}
      mode="inline"
      openKeys={openKeys}
      onClick={() => setVisible(false)}
      onOpenChange={onOpenChange}
      style={{
        width: "100%",
        padding: "2rem 0rem",
      }}
      items={items}
    />
  );
};

export default Inlinenavbar;
